"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _emptyState = _interopRequireDefault(require("@atlaskit/empty-state"));
var _reactRouterDom = require("react-router-dom");
var _colors = require("../../style/colors");
var _reactIntl = require("react-intl");
var _Text = require("../../Text/Text");
var _styles = require("@material-ui/styles");
var _ButtonInput = _interopRequireDefault(require("../../Input/ButtonInput/ButtonInput"));
var _logoSquare = _interopRequireDefault(require("@catalytic/catalytic-icons/lib/icons/logo-square.svg"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/*:: import { type ThemeType } from '../../style/ThemeTypes';*/
/*:: type ButtonInputType = React.Element<typeof ButtonInput>;*/
var useStyles = (0, _styles.makeStyles)(function (theme /*: ThemeType*/) {
  return {
    headerText: {
      color: theme.colors.black
    },
    descriptionText: {
      color: theme.colors.pebbleGrey
    }
  };
});
function EmptyState(props
/*: {|
  description?: string | React.Element<typeof FormattedMessage>,
  header?: string | React.Element<typeof FormattedMessage>,
  imageUrl?: string | null,
  primaryAction?: ButtonInputType,
  secondaryAction?: ButtonInputType,
  tertiaryAction?: React.Element<typeof Link>
|}*/
) {
  var description = props.description,
    header = props.header,
    _props$imageUrl = props.imageUrl,
    imageUrl = _props$imageUrl === void 0 ? _logoSquare.default : _props$imageUrl,
    primaryAction = props.primaryAction,
    secondaryAction = props.secondaryAction,
    tertiaryAction = props.tertiaryAction;
  var classes = useStyles();
  var primaryButton = primaryAction != null ? React.cloneElement(primaryAction, {
    colorScheme: _colors.SCIENCE_BLUE
  }) : null;
  var secondaryButton = primaryAction && secondaryAction != null ? React.cloneElement(secondaryAction, {
    invertScheme: true,
    colorScheme: _colors.BLACK
  }) : null;
  return /*#__PURE__*/React.createElement(_emptyState.default, {
    description: /*#__PURE__*/React.createElement(_Text.BaseText, {
      className: classes.descriptionText,
      component: "span"
    }, description),
    header: /*#__PURE__*/React.createElement(_Text.Header3, {
      className: classes.headerText,
      component: "span"
    }, header),
    imageUrl: imageUrl,
    maxImageWidth: '54',
    maxImageHeight: '48',
    primaryAction: primaryButton,
    secondaryAction: secondaryButton,
    tertiaryAction: /*#__PURE__*/React.createElement(_Text.BaseText, {
      component: "span"
    }, tertiaryAction)
  });
}
var _default = exports.default = EmptyState;
//# sourceMappingURL=EmptyState.js.map